import { NoteReceivableFormValues } from '..';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import { NotesV2 } from '../../UI/components/Form';

interface NoteReceivableNotesInputProps {
  className?: string;
}

export const NoteReceivableNotesInput = ({ className }: NoteReceivableNotesInputProps) => {
  const { t: tCommon } = useTranslation('common');
  const { control } = useFormContext<NoteReceivableFormValues>();
  const { field, fieldState } = useController<NoteReceivableFormValues, 'notes'>({
    control,
    name: 'notes',
  });

  return (
    <NotesV2
      {...field}
      className={className}
      label={tCommon('notes')}
      defaultValue={field.value}
      status={fieldState.error ? 'errored' : 'normal'}
    />
  );
};
